<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Departamento' : 'Cadastrar Departamento' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <!-- Status -->
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardHeader>
            <LanguageContentHeader
              @change="(index) => activeTabIndex = index"
            ></LanguageContentHeader>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <CRow>
                  <!-- Title -->
                  <CCol lg="6">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                      required
                    />
                  </CCol>

                  <!-- Email -->
                  <CCol lg="6">
                    <CInput
                      v-model="form.email"
                      label="Email*"
                      placeholder="email@email.com;email2@email.com"
                      required
                      :disabled="processing"
                      :is-valid="isValidResponsibleEmails"
                      invalid-feedback="Por favor, insira e-mails válidos"
                      description="Para múltiplos e-mails, separe colocando ';' (ponto e vírgula) ao final de cada e-mail sem espaço"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Tabs -->
        <CCard id="languages">
          <CCardHeader>
            <h5 class="mb-0">
              Idiomas
            </h5>
          </CCardHeader>

          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <CRow>
                      <!-- Title -->
                      <CCol lg="6">
                        <CInput
                          id="first"
                          v-model="form.title"
                          label="Título*"
                          :disabled="processing"
                        />
                      </CCol>

                      <!-- Email -->
                      <CCol lg="6">
                        <CInput
                          v-model="form.email"
                          label="Email*"
                          placeholder="email@email.com;email2@email.com"
                          :disabled="processing"
                          description="Para múltiplos e-mails, separe colocando ';' (ponto e vírgula) ao final de cada e-mail sem espaço"
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import Modal from '@/components/ui/Modal'
import TabsStatus from '@/components/ui/TabsStatus'
import CardLog from '@/components/ui/CardLog'

import moment from 'moment'
import { cloneDeep } from 'lodash'
import { isValidEmail } from '@/utils'

// Services
import Service from '@/services/department.service'

export default {
  metaInfo: {
    title: 'Departamento',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_contacts')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal,
    TabsStatus,
    CardLog
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        title: '',
        title_en: '',
        title_es: '',
        email: '',
        status: true,
        status_en: false,
        status_es: false
      },
      form: {},
      processing: false,
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },

  computed: {
    isValidResponsibleEmails() {
      const emails = this.form.email
      if (emails === this.item.email || !emails) return null
      return emails
        .split(';')
        .reduce((prev, next) => prev && (!next || isValidEmail(next)), true)
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            email: data.email,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      if (this.isValidResponsibleEmails === false) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Por favor insira emails válidos',
          color: 'danger'
        }

        return false
      }

      this.processing = true

      let response
      let message

      const data = {
        ...this.form,
        id: this.$route.params.id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        email: this.form.email,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Departamento foi atualizado com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Departamento foi cadastrado com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
